<style scoped>
    .search-input{
        display: inline-block;
        width: 200px;
    }
    .item{
        border: 1px solid #dddee1;
        border-radius: 6px;
        padding: 6px 12px;
        margin: 5px 0;
        cursor: pointer;
    }
    .item:hover{
        background: #dddee1;
    }
    .item-hover-text{
        display: none;
        float: right;
        color: #999;
    }
    .item:hover .item-hover-text{
        display: inline-block;
    }

    .search-customer-container{
        width: 400px;
        margin: 0 auto;
        text-align: left;
    }
</style>
<template>
  <div>
    <Row>
      <i-col span="8">
        <Tabs
          type="card"
          @on-click="tabChange"
        >
          <TabPane
            label="批量设置负责人"
            name="director"
          >
            <div class="line text-large">
              目标负责人:
              <div
                v-if="target_director.id"
                class="line text-bold"
              >
                <span>{{ target_director.account }} - </span>
                <span>{{ target_director.uid || '没有工号' }} - </span>
                <span>{{ target_director.team }}</span>
              </div>
              <div
                v-else
                class="line"
              >
                未选择
              </div>
            </div>
            <div class="line">
              <i-input
                v-model="search_target_director_text"
                placeholder="搜索目标负责人"
                @on-enter="searchDirector"
              >
                <span slot="prepend">搜索</span>
                <Button
                  slot="append"
                  :loading="search_target_director_loading"
                  icon="ios-search"
                  @click="searchDirector"
                />
              </i-input>
            </div>
            <div class="line">
              <div
                v-for="director in search_target_director_result"
                :key="director.id"
                class="item"
                :class="{'item-disabled': isTargetDirector(director)}"
                @click="setTargetDirector(director)"
              >
                <span>{{ director.account }} - </span>
                <span>{{ director.uid || '没有工号' }} - </span>
                <span>{{ director.team }}</span>
                <span class="item-hover-text">选择</span>
              </div>
            </div>
          </TabPane>
          <TabPane
            label="批量设置团队"
            name="team"
          >
            <div class="line text-large">
              目标团队:
            </div>
            <Select
              v-model.number="target_team_id"
              transfer
              placeholder="团队"
              style="width: 200px"
            >
              <Option :value="0">
                未选择
              </Option>
              <Option
                v-for="team in teams"
                :key="team.id"
                :value="team.id"
              >
                {{ team.name }}
              </Option>
            </Select>
          </TabPane>
        </Tabs>
      </i-col>
      <i-col
        class="text-center"
        span="16"
      >
        <div class="line text-large">
          搜索你要处理的员工
        </div>
        <div class="line">
          <Select
            v-model.number="search_customer_params.team_id"
            placeholder="团队"
            style="width: 100px"
          >
            <Option :value="0">
              所有团队
            </Option>
            <Option
              v-for="team in teams"
              :key="team.id"
              :value="team.id"
            >
              {{ team.name }}
            </Option>
          </Select>
          <Select
            v-model="search_customer_params.search_type"
            style="width:100px"
          >
            <Option :value="0">
              按员工姓名
            </Option>
            <Option :value="1">
              按负责人姓名
            </Option>
          </Select>
          <div class="search-input">
            <i-input
              v-model="search_customer_params.search"
              placeholder="请输入搜索内容"
              @on-enter="doSearch"
            />
          </div>
          <Ajaxbtn
            ref="searchBtn"
            :url="search_customers_path"
            :params="search_customer_params"
            type="search"
            @before="beforeSearch"
            @done="handleData"
            @fail="handleFail"
          />
        </div>
        <div class="line search-customer-container">
          <div
            v-show="page_info.total"
            class="line"
          >
            <Page
              :current="page_info.current"
              :total="page_info.total"
              :page-size="page_info.page_size"
              size="small"
              show-total
              @on-change="pageChange"
            />
          </div>
          <div
            v-show="search_customers.length"
            class="line"
          >
            <Checkbox
              :indeterminate="indeterminate"
              :value="select_all"
              @click.prevent.native="handleSelectAll"
            >
              全选本页
            </Checkbox>
            <Button
              v-show="can_set_director"
              type="primary"
              :loading="processing"
              @click="batchSetDirector"
            >
              批量设置为目标负责人
            </Button>
            <Button
              v-show="can_set_team"
              type="primary"
              :loading="processing"
              @click="batchSetTeam"
            >
              批量设置为目标团队
            </Button>
          </div>
          <CheckboxGroup
            v-model="select_customer_ids"
            @on-change="selectAllGroupChange"
          >
            <Checkbox
              v-for="customer in search_customers"
              :key="customer.id"
              :label="customer.id"
              :disabled="disabled(customer)"
            >
              <span>{{ customer.account }} - </span>
              <span>{{ customer.uid || '没有工号' }} - </span>
              <span>{{ customer.team }} - </span>
              <span>负责人: {{ customer.director || '未指定' }}</span>
            </Checkbox>
          </CheckboxGroup>
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script route="/hr/batch_operation">
  import Util from '../../libs/util';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/hr/batch_operation',
    /* router_info_end */

    data() {
      return {
        mode: 'director',
        search_customers_path: Util.api.query_customer_for_batch_operation,
        search_target_director_text: '',
        search_target_director_result: [],
        search_target_director_loading: false,
        target_director: {},
        target_team_id: 0,
        search_customer_params: {
          search: '',
          search_type: 0, //0 员工姓名, 1 负责人姓名
          team_id: 0,
          customer_type: 'informal', //informal, formal, all
          page: 1,
          per_page: 20
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        search_customers: [],
        select_customer_ids: [],
        select_all: false,
        indeterminate: false,
        processing: false
      }
    },
    computed: {
      can_set_director() {
        return this.mode === 'director' && this.target_director.id && this.select_customer_ids.length;
      },
      can_set_team() {
        return this.mode === 'team' && this.target_team_id && this.select_customer_ids.length;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      })
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      tabChange(name) {
        this.mode = name;
        if (name === 'director') {
          this.search_customer_params.customer_type = 'informal';
        } else if (name === 'team') {
          this.search_customer_params.customer_type = 'all';
        }
      },
      searchDirector() {
        if (!this.search_target_director_loading) {
          this.search_target_director_loading = true;
          Util.ajax.get(Util.api.query_director, {
            params: {
              search: this.search_target_director_text
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.search_target_director_loading = false;
            this.search_target_director_result = [];
            if (res.code === 1) {
              const data = res.data;
              data.forEach((director) => {
                this.search_target_director_result.push(director);
              });
              if (this.search_target_director_result.length === 0) {
                this.$Message.error('没有搜索结果');
              }
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.search_target_director_loading = false;
            console.log(e);
          });
        }
      },
      setTargetDirector(director) {
        this.target_director = director;
      },
      isTargetDirector(director) {
        return this.target_director.id === director.id;
      },
      checkSearchCustomerParams() {
        if (!this.search_customer_params.search) {
          this.$Message.warning('请输入你要搜索的内容!');
          return false;
        }
        return true;
      },
      beforeSearch() {
        this.search_customer_params.page = 1;
        this.search_customers = [];
      },
      doSearch() {
        this.$refs.searchBtn.doAjax(true);
      },
      pageChange(new_page) {
        this.search_customer_params.page = new_page;
        this.doSearch();
      },
      handleData(data) {
        console.log(data);
        this.search_customers = [];
        data.customers.forEach((customer) => {
          this.search_customers.push(customer);
        });
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        console.log(e);
      },
      isSelected(customer) {
        const len = this.selected_customers.length;
        for (let i = 0; i < len; i++) {
          if (this.selected_customers[i].id === customer.id) {
            return true;
          }
        }
        return false;
      },
      selectCustomer(customer) {
        if (!this.isSelected(customer)) {
          this.selected_customers.push(customer);
        }
      },
      disabled(customer) {
        if (this.mode === 'director') {
          return !this.target_director.id || this.target_director.id === customer.director_id;
        } else if (this.mode === 'team') {
          return !this.target_team_id || this.target_team_id === customer.team_id;
        } else {
          return false;
        }
      },
      handleSelectAll() {
        if (this.indeterminate) {
          this.select_all = false;
        } else {
          this.select_all = !this.select_all;
        }
        this.indeterminate = false;

        this.select_customer_ids = [];
        if (this.select_all) {
          this.search_customers.forEach((customer) => {
            if (!this.disabled(customer)) {
              this.select_customer_ids.push(customer.id);
            }
          });
        }
      },
      selectAllGroupChange(data) {
        let can_select_len = 0;
        this.search_customers.forEach((customer) => {
          if (!this.disabled(customer)) {
            can_select_len++;
          }
        });
        console.log(can_select_len, data.length, data);
        if (data.length === can_select_len) {
          this.indeterminate = false;
          this.select_all = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.select_all = false;
        } else {
          this.indeterminate = false;
          this.select_all = false;
        }
      },
      batchSetDirector() {
        if (!this.target_director.id) {
          this.$Modal.error({title: '提示', content: '未指定目标负责人!'});
          return;
        }
        if (!this.select_customer_ids.length) {
          this.$Modal.error({title: '提示', content: '请勾选需要处理的员工!'});
          return;
        }
        if (!this.processing) {
          this.processing = true;
          const director = this.target_director;
          Util.ajax.post(Util.api.batch_set_director, {
            customer_ids: this.select_customer_ids,
            director_id: director.id
          }).then((response) => {
            return response.data;
          }).then((data) => {
            this.processing = false;
            if (data.code === 1) {
              let msg = `<p>${data.accounts.join(',')}</p>`;
              msg += `<p>以上员工负责人已批量更新为 [${director.account}]</p>`;
              this.$Modal.success({
                title: '设置成功!',
                content: msg
              });
              this.select_customer_ids = [];
              this.doSearch();
            } else {
              this.$Modal.error({
                title: '提示',
                content: data.msg
              });
            }
            console.log(data);
          }).catch((e) => {
            this.processing = false;
            this.$Message.error('设置失败, 请重试!');
            console.log(e);
          });
        }
      },
      batchSetTeam() {
        if (!this.target_team_id) {
          this.$Modal.error({title: '提示', content: '未选择目标团队!'});
          return;
        }
        if (!this.select_customer_ids.length) {
          this.$Modal.error({title: '提示', content: '请勾选需要处理的员工!'});
          return;
        }
        if (!this.processing) {
          this.processing = true;
          const team = this.teams_hash[this.target_team_id];
          Util.ajax.post(Util.api.batch_set_team, {
            customer_ids: this.select_customer_ids,
            team_id: team.id
          }).then((response) => {
            return response.data;
          }).then((data) => {
            this.processing = false;
            if (data.code === 1) {
              let msg = `<p>${data.accounts.join(',')}</p>`;
              msg += `<p>以上员工的团队已批量更新为 [${team.name}]</p>`;
              this.$Modal.success({
                title: '设置成功!',
                content: msg
              });
              this.select_customer_ids = [];
              this.doSearch();
            } else {
              this.$Modal.error({
                title: '提示',
                content: data.msg
              });
            }
            console.log(data);
          }).catch((e) => {
            this.processing = false;
            this.$Message.error('设置失败, 请重试!');
            console.log(e);
          });
        }
      }
    }
  }
</script>
